module.exports = __webpack_public_path__ + "img/clock.42840f12.svg";